import { render, staticRenderFns } from "./RatingInputRenderer.vue?vue&type=template&id=54b26077"
import script from "./RatingInputRenderer.vue?vue&type=script&lang=js"
export * from "./RatingInputRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports